var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 206,
    viewBox: "0 0 121 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6889 40.0431C47.5835 29.2577 53.45 24.5526 61.4475 20.5599C69.1349 16.721 78.0315 16.842 86.4985 20.8992C106.218 30.3426 100.614 58.4545 100.332 59.7976L73.0573 168.538C70.3783 179.027 65.2374 186.095 58.5884 188.42C52.937 190.397 46.5191 188.842 40.0136 183.922C25.9432 173.274 32.639 151.761 32.7081 151.544C32.7542 151.401 32.7937 151.255 32.8266 151.107L49.515 75.7393C50.1012 73.0934 48.4296 70.4742 45.7847 69.8883C43.1388 69.3021 40.5189 70.9724 39.9327 73.6183L23.2856 148.796C22.8875 150.125 21.1321 156.446 21.2594 164.194C21.4533 176.013 25.8892 185.54 34.0898 191.746C43.2032 198.644 53.0513 200.751 61.8254 197.682C71.6776 194.237 79.0441 184.741 82.568 170.945L109.867 62.1057C109.877 62.064 109.887 62.022 109.897 61.9801C109.979 61.6102 111.904 52.7946 110.679 42.4045C109.19 29.7743 103.714 20.1527 94.755 14.3048C93.4847 13.476 92.1456 12.7238 90.7358 12.0477C79.4777 6.65313 67.5185 6.5575 57.0604 11.7789C46.4773 17.063 38.4048 26.2796 33.6891 40.043L43.6889 40.0431Z",
    fill: "#BB230B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.56685de70d866c00c3e98ddd0de9fffd.svg";
export { ForwardRef as ReactComponent };